import { z } from "zod";
/**
 * Closed set of machine-readable reasons admin-control attaches to a denied
 * sign-in as `mlx_reason` (error redirects and JSON error bodies). Relying
 * parties map each to fixed copy and never echo `error_description`; both
 * sides import this enum so the set cannot drift.
 */
export const oidcDenialReasonSchema = z.enum([
    "invite_only",
    "organization_required",
    "organization_not_mapped",
    "organization_not_allowed",
    "organization_selection_required",
    "tenant_mismatch",
    "sign_in_method_not_allowed",
    "enterprise_sso_required",
    "upstream_denied",
    "user_declined",
    "sign_in_expired",
]);
export const OIDC_DENIAL_REASONS = oidcDenialReasonSchema.options;
